<template style="">
  <div class="Game_a_type">
    <div class="yj-view" v-loading="loading">
      <div class="left">
          <!-- <img src="../images/反应速度测试.png" alt="" width="380" height="230"> -->
      </div>
      <div class="right">
          <h2>{{ info.GameName }}</h2>
          <label>训练描述:</label>
          <p>{{ info.Guideline }}</p>

          <div class="btn-group">
            <div class="btn-left">
                <button @click="startTest(0)" class="yj-btn">练习</button>
                <button @click="startTest(1)" class="yj-btn">正式</button>
            </div>
          </div>
      </div>
    </div>

     <el-dialog style="display: none;" :show-close="false" class="bg-black" :fullscreen="true" title="" :visible.sync="dialogVisible">
              <div class="stage" id="stage" ref="stage">
                  <div class="text-center text-white ready-dot" v-if="pageShowStatus === 0">
                      [ {{ targetLetter }} ]
                  </div>
                  <div class="warpper" v-else-if="pageShowStatus === 1">
                      <div class="head text-center text-white">
                          <span>本轮寻找：[ {{ targetLetter }} ]</span>
                          <span style="">{{ speeds[currentSpeedIndex].name }}</span>
                      </div>

                      <div class="list-wrapper">
                          <ul class="list" ref="list">
                              <li class="row-item" v-for="(row, rowIdx) in datalist" :key="'row' + rowIdx">
                                  <span class="cell-item" :class="item.isSelected && 'active'"
                                      @click="selected(item, rowIdx, cellIdx)" v-for="(item, cellIdx) in row"
                                      :key="'cell' + cellIdx">{{ item.name }}</span>
                              </li>
                          </ul>
                      </div>
                  </div>

                  <div v-else style="height: 100%; font-size: 30px;"
                      class="d-flex flex-column justify-content-center text-center">
                      <div v-if="!finished">
                          <div class="report">
                              <h2>本次练习的目标个数为：{{ targetLetterNum }}</h2>
                              <h2>正确个数为：{{ selectedData.correctNum }}</h2>
                              <h2>遗漏个数为：{{ targetLetterNum - selectedData.correctNum }}</h2>
                              <h2>正确率：{{ (selectedData.correctNum / targetLetterNum).mul(100) }}%</h2>
                          </div>
                          <button v-if="currentSpeedIndex === 2" class="btn" style="margin: 0 auto;"
                                  @click="handleEndExercise()">
                              确定
                          </button>
                          <button v-else class="btn" style="margin: 0 auto;" @click="handleContinueTest()">提交</button>
                      </div>
                      <div v-else>
                          <div class="report">
                              <h1>本回合</h1>
                              <h1>测验结束！</h1>
                              <!--<h1>您的平均正确率为：{{correctRate}}%</h1>-->
                          </div>
                      </div>
                  </div>
              </div>
          </el-dialog>

  </div>
</template>
<script>
Number.prototype['mul'] = function (...arg) {
  var result = this;
  arg.forEach(value => {
    var m = 0, s1 = result.toString(), s2 = value.toString();
    try { m += s1.split(".")[1].length } catch (e) { }
    try { m += s2.split(".")[1].length } catch (e) { }
    result = Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m);
  });
  return result;
};
export default {
  data() {
    return {
      finished: false,
      gameMode: 0, // 0：练习   1:正式
      currentSpeedIndex: 0,
      speeds: [{id: 1,name: '低速',time: 20,testNum: 5,}, {id: 2,name: '中速',time: 13,testNum: 5,}, {id: 3,name: '高速',time: 10,testNum: 5}],
      charCodeList: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],
      dialogVisible: false,
      targetLetterNum: 25, // 目标字母数量
      targetLetter: this.axs(['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']),
      datalist: [],
      pageShowStatus: 0, //页面内容显示状态 0:注释点 1:游戏页 2:结果
      timer: null, //定时器
      startTime: 0, //开始时间戳
      startTimeDate: '', //开始日期时间
      endTime: 0, //结束时间戳
      reportID: "", //游戏编号
      publishID: "", //发布编号
      selectedData: { errorNum: 0, correctNum: 0 }, // 选择的数据
      result: [], //结果
      count: 0,
      info: '',
      loading:true
    }
  },
  mounted() {
    this.getApi();
    this.initTargetLetterList()
  },
  methods: {
    formatDate(date) {
      var date = new Date(date);
      var YY = date.getFullYear() + '-';
      var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
      var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
      var hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
      var mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
      var ss = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
      var fff = date.getMilliseconds() >= 100 ? date.getMilliseconds() : date.getMilliseconds() >= 10 ? '0' + date.getMilliseconds() : '00' + date.getMilliseconds();
      return YY + MM + DD + " " + hh + mm + ss;
    },
    axs(val) {
      var jij = val[Math.round(Math.random() * 25)];
      return jij;
    },
    getUrlParam(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //
      var r = window.location.search.substr(1).match(reg); //
      if (r != null) return decodeURIComponent(r[2]);
      return null; //
    },
    // 获取初始数据
    getApi() {
      this.loading = false;
      this.reportID = this.getUrlParam('UserID');
      this.publishID = this.getUrlParam('PublishID');
    },
    // 正式测试
    startTest(modu) {
      this.gameMode = modu
      this.dialogVisible = true;
      this.commentsPoint();
    },
    // 初始化
    initTargetLetterList() {
      var row = 10
      var cell = 10
      var list = []
      // 目标行比例分布
      var aimsRowScales = new Array(row).fill(1)
      for (var i = 0; i < this.targetLetterNum - row; i++) {
        var num = parseInt(Math.random() * cell)
        aimsRowScales[num] += 1
      }
      for (var i = 0; i < row; i++) {
        var cellList = []
        var cellIndexs = []
        for (var n = 0; n < aimsRowScales[i]; n++) {
          var _index = this.getRandom(0, 9, cellIndexs)
          cellIndexs.push(_index)
        }
        for (var j = 0; j < cell; j++) {
          if (cellIndexs.indexOf(j) === -1) {
            cellList.push({ name: this.getRandomcharCode(this.targetLetter), isSelected: false })
          } else {
            cellList.push({ name: this.targetLetter, isSelected: false })
          }
        }
        list.push(cellList)
      }
      this.datalist = list
    },

    getRandomcharCode(aimsCharCode) {
      var code = this.charCodeList[Math.round(Math.random() * 25)]
      if (aimsCharCode === code) {
        return this.getRandomcharCode(aimsCharCode)
      } else {
        return code
      }
    },
    getRandom(n, m, list = []) {
      n = Number(n); //要么是一个数，要么是NaN
      m = Number(m);
      if (isNaN(n) || isNaN(m)) {
        return Math.random();
      }
      if (n > m) {
        var temp = n;
        n = m;
        m = temp;
      }
      var num = Math.round(Math.random() * (m - n) + n)
      if (list.indexOf(num) !== -1) {
        return this.getRandom(n, m, list)
      }
      return num;
    },
    //注视点界面消失
    commentsPoint() {
      let that = this;
      setTimeout(function () {
        that.pageShowStatus = 1;
        that.startTime = new Date().getTime();
        that.startTimeDate = that.formatDate(that.startTime);
        that.gameTimeFun();
      }, 1000)
    },
    //游戏总时间
    gameTimeFun() {
      var time = this.speeds[this.currentSpeedIndex].time;
      var second = Math.floor(time / 6 * 80) / 80;
      var count = 0;
      var d = (second / 2).toFixed(2) * 800;
      setTimeout(() => {
        var listStyle = this.$refs.list
        count += 80
        listStyle.style.transform = 'translateY(-' + count + 'px)'
        listStyle.style.webkitTransform = 'translateY(-' + count + 'px)'
        listStyle.style.transition = 'transform ' + second * 800 + 'ms linear'
        listStyle.style.webkitTransition = 'transform ' + second * 800 + 'ms linear'
        this.timer = setInterval(() => {
          time = Math.floor((time - second) * 80) / 80
          if (count < 400) count += 80
          listStyle.style.transform = 'translateY(-' + count + 'px)'
          listStyle.style.webkitTransform = 'translateY(-' + count + 'px)'
          listStyle.style.transition = 'transform ' + second * 800 + 'ms linear'
          listStyle.style.webkitTransition = 'transform ' + second * 800 + 'ms linear'
          if (Math.floor((time - second) * 80) / 80 < 1) {
            clearInterval(this.timer)
            count = 0
            setTimeout(() => {
              this.gameMode === 0 ? this.practiceResultFun() : this.resultFun()
            }, d)
          }
        }, second * 800);
      }, d)
    },
    transition() {

    },
    selected(item, rowIndex, cellIndex) {
      var target = this.datalist[rowIndex][cellIndex]
      // 如果已经选过了，则直接return
      if (target.isSelected) {
        return;
      }
      target.isSelected = true;
      // 正确
      if (item.name === this.targetLetter) {
        this.selectedData.correctNum++
      }
      // 错误
      else {
        this.selectedData.errorNum++
      }
    },
    // 练习测试结果
    practiceResultFun() {
      this.pageShowStatus = 2
      var end = new Date().getTime()
      var diff = end - this.startTime
    },
    /*
     * 结果函数
     * 参数 result 0:正确 1:错误 2:遗漏
     *
     **/
    resultFun() {
      var currentItem = this.speeds[this.currentSpeedIndex];
      currentItem.testNum--;
      this.count++;
      this.endTime = new Date().getTime();
      this.datalist = [];
      var obj = {};
      obj.GameID = 'YJ-05'; //游戏编号
      obj.ReportID = this.reportID; //报告编号
      obj.PublishID = this.publishID; //发布编号
      obj.StartTime = this.startTimeDate;//开始时间
      obj.EndTime = this.formatDate(this.endTime);//结束时间
      obj.No1 = this.count; //序号
      obj.DiffName = this.speeds[this.currentSpeedIndex].name;
      obj.CorrectNum = this.selectedData.correctNum;
      obj.ErrorNum = this.selectedData.errorNum;
      obj.OmissionNum = this.targetLetterNum - this.selectedData.correctNum;
      if (this.result.length + 1 == 1) {
        obj.ReportID = obj.ReportID + "_" + this.publishID;
      }
      this.result.push(obj);
      // 切换下一速度
      if (currentItem.testNum <= 0) {
        this.currentSpeedIndex++;
      }
      // 测试结束
      if (this.currentSpeedIndex >= 3) {
        this.pageShowStatus = 2;
        this.submitData();
        return false;
      }
      if (this.currentSpeedIndex < this.speeds.length) {
        var listdom = this.$refs.list;
        listdom.style.transition = '';
        listdom.style.webkitTransition = '';
        listdom.style.transform = '';
        listdom.style.webkitTransform = '';
        setTimeout(() => {
          this.startTime = new Date().getTime();
          this.startTimeDate = this.formatDate(this.startTime);
          this.selectedData = { errorNum: 0, correctNum: 0 }
          this.initTargetLetterList();
          this.gameTimeFun();
        }, 800);
      }
    },
    handleContinueTest() {
      this.currentSpeedIndex++;
      this.pageShowStatus = 0;
      this.selectedData = { errorNum: 0, correctNum: 0 }
      this.initTargetLetterList();
      var that = this;
      setTimeout(function () {
        that.pageShowStatus = 1;
        that.startTime = new Date().getTime();
        that.gameTimeFun();
      }, 1000)
    },
    handleEndExercise() {
      this.dialogVisible = false
      this.pageShowStatus = 0
      this.selectedData = { errorNum: 0, correctNum: 0 }
      this.currentSpeedIndex = 0
      this.targetLetter = this.charCodeList[Math.round(Math.random() * 25)]
      this.initTargetLetterList()
    },
    //获取报告编号
    getGetReportID() {
      return new Promise((resolve, rej) => {
        $request.get('/Api/Game9/GetReportID?PadID=' + this.getUrlParam('PadID')).then(res => {
          for (let i = 0; i < this.result.length; i++) {
            this.result[i].ReportID = this.reportID;//res.data.Data.ReportID
            this.result[i].PublishID = this.publishID;
          }
          addCookie('ReportID', res.data.Data.ReportID);
          resolve()
        });
      })
    },
    submitData: function () { 
    }
  },
  computed: {
    correctRate() {
      var count = 0
      var total = this.targetLetterNum * 15
      this.result.forEach(item => {
        count += item.CorrectNum
      })
      var num = count / total * 80 > 0 ? (count / total * 80).toFixed(2) : 0;
      return num
    }
  },
}

</script>

<style>
  .Game_a_type{width: 100%;height: 100%;position: relative;}
  .warpper {width: 100%;box-sizing: border-box;overflow: hidden;}
  .head {width: 800px;display: flex;justify-content: space-between;font-size: 28px;margin: 30px auto 30px;}
  .list-wrapper {width: 800px;height: 400px;margin: auto;overflow: hidden;}
  .list {margin: 0 auto;list-style: none;padding: 0;}
  .list .row-item {width: 100%;display: flex;height: 80px;}
  .list .row-item .cell-item {width: 80px;line-height: 80px;text-align: center;background-color: #fff;border-top: 1px dashed #14b12e;border-right: 1px dashed #14b12e;font-size: 24px;color: #14b12e;cursor: pointer;}
  .list .row-item .cell-item.active {background-color: #56d262;color: #f7f6f6;opacity: 0.9;transition: all 0.3s;}
  .report {margin-bottom: 30px;color: #fff;}
  .el-dialog.is-fullscreen {background-color: #000000;}
  .el-dialog__wrapper{position: absolute;}
</style>
